export const config = {
    useLinkedIn: false,
    production: false,
    version: '0.0.0',
    lrsUrl: 'https://lrs.mgig.peblproject.com/',
    lrsCredential: 'ZGZmYjJkOTcwNzNlNjBmOWNlMWU3NTQ5MWQ1YWFkNGVmMjZmMjA1MjoxNTViMDc4ZjNiNDg3OGEyMjQyZjdhNTc2ODQ3NGZiNDhiZTNiZGJl',
};
